import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { useFTS0018ExperimentEffect } from './fts0018';
import { useFTS0019ExperimentEffect } from './fts0019';
export const useFTS0017orFTS0018ExperimentEffect = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);

  // FTS0019 is the new version of FTS0017 in-app
  // The only difference is that FTS0019 doesn't show the free merch card on product pages
  const {
    isFTS0019Loading,
    isFTS0019Variant
  } = useFTS0019ExperimentEffect();
  // FTS0018 is the public version of the experiment
  const {
    isFTS0018Loading,
    isFTS0018Variant
  } = useFTS0018ExperimentEffect();
  if (isAppAuth) {
    return {
      loading: isFTS0019Loading,
      variant: isFTS0019Variant
    };
  } else {
    return {
      loading: isFTS0018Loading,
      variant: isFTS0018Variant
    };
  }
};